<template>
  <div>
    <div v-for="(table, i) in data.tables" :key="i">
      <vs-divider color="danger" class="my-6 f-14 f-bold">
        {{ table.fileName }}
      </vs-divider>
      <div class="vx-row mt-6" v-if="invoiceInfo.length !== 0">
        <div class="vx-col sm:w-2/3 w-full ml-auto">
          <table class="custom-text">
            <tr>
              <td class="font-semibold">{{ $t('invoice') | capitalize }}:</td>
              <td class="pl-2">{{ invoiceInfo[i].invoice }}</td>
            </tr>
            <tr>
              <td class="font-semibold">{{ $t('bundles') | capitalize }}:</td>
              <td class="pl-2">{{ invoiceInfo[i].bundles }}</td>
            </tr>
            <tr>
              <td class="font-semibold">{{ $t('code') | capitalize }}:</td>
              <td class="pl-2">{{ invoiceInfo[i].code }}</td>
            </tr>
            <tr>
              <td class="font-semibold">
                {{ $t('review_at_origin') | capitalize }}:
              </td>
              <td class="pl-2">{{ data.isReviewAtOrigin ? $t('yes') : $t('no') | capitalize}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="vx-row mt-6">
        <div class="vx-col w-full">
          <vs-table stripe search :data="table.tableData">
            <template slot="header">
              <h4>
                {{ table.fileName }}
              </h4>
            </template>

            <template slot="thead">
              <vs-th
                :sort-key="heading"
                v-for="heading in table.headers"
                :key="heading"
                >{{ heading }}</vs-th
              >
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td
                  :data="col"
                  v-for="(col, indexcol) in data[indextr]"
                  :key="indexcol + col"
                >
                  {{ col }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    invoiceInfo: {
      type: Array,
      deffault: () => []
    },
    data: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style></style>
